import { Container, Input, Checkbox, Select } from "components";
import { IndicatorSource } from "domain/models";
import { useTranslation } from "react-i18next";
import { asSelect } from 'domain/utils';
import { useVariableState } from 'domain/swr/indicator';
import { useAdminExternalDataSources } from 'domain/swr/admin/indicator';
import { AdminFormProps } from '../components/admin-forms/models';
import { AdminForm } from '../components/admin-forms/AdminForm';

export const AdminSourceForm = (
  {
    formState,
    updateField,
    error,
  }: AdminFormProps<IndicatorSource>) => {

  const { t } = useTranslation([ 'common', 'admin' ]);
  const { data: externalDataSources } = useAdminExternalDataSources();
  const { data: variableStates } = useVariableState();
  const externalDataSourcesOptions = asSelect(externalDataSources)
  const variables = variableStates.content.map(v => ({ value: v.code, label: `${v.code} - (${v.variable})`}));

  return (
    <AdminForm error={error}>
      <Container className='edit-field'>
        <label>
          {t('admin:source.name')}
        </label>
        <Input
          value={formState.code}
          onChange={(e: any) => updateField('code', e.target.value)}
        />
      </Container>
      <Container className='edit-field'>
        <label>
          {t('admin:source.externalDataSource')}
        </label>
        <Select
          value={externalDataSourcesOptions.find(v => v.value === formState.externalDataSource)}
          onChange={(e: any) => updateField('externalDataSource', parseInt(e.value))}
          options={externalDataSourcesOptions}
        />
      </Container>
      <Container className='edit-field'>
        <label>
          {t('admin:source.references')}
        </label>
        <Select
          isMulti
          value={formState.references.map(reference =>
            variables.find(v => v.value === reference.code)
          )}
          onChange={(selected: any[]) => updateField('references', selected.map(v => ({ code: v.value })))}
          options={variables}
        />
      </Container>
      <Container className='edit-field'>
        <label>
          {t('admin:source.active')}
        </label>
        <Checkbox
          checked={formState.active}
          onChange={(e: any) => updateField('active', e.target.checked)}
        />
      </Container>
    </AdminForm>);
}
